import { defineMessages } from 'react-intl';

export default defineMessages({
  MEINE_QUESTS: {
    defaultMessage: 'Mes quêtes',
  },
} as const);
